/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	08-03-2019
	- [CHANGE] Added variable check to set height and with when not given in on windowResize();
	11-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_window = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
		/**
		Window: resize
		**/
		this.windowResize = function(scrolled,h,w) {
			
			/*
			Set: Variables
			*/
			if(typeof h === 'undefined') {
				h = $(window).height();
			}
			if(typeof w === 'undefined') {
				w = $(window).width();
			}

			/*
			Fix: 100% Height mobile
			*/
			document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
			
		};
		
		/**
		Window: scroll
		**/
		this.windowScroll = function(scrolled,h,w) {

			/*
			View header menu
			*/
			var _spotlight_height = $(window).height();

			if (scrolled >= _spotlight_height) {
				
				$('header').stop().animate({
					'top':0
				},400,'swing');

			} else {

				$('header').stop().animate({
					'top': -($('header').height() + 50)
				},400,'swing');

			}

			/*
			Active page
			*/
			var _height_page_inzet 			= $('.page--inzet').offset().top - 100;
			var _height_page_achtergrond 	= $('.page--achtergrond').offset().top - 100;
			var _height_page_vaardigheden 	= $('.page--vaardigheden').offset().top - 100;
			var _height_page_contact 		= $('.page--contact').offset().top - 100;

			var _active_page;

			if(scrolled <= _height_page_inzet) {
				_active_page 	= 'home';
				document.title 	= "Peterse Interim Finance";
			}
			if(scrolled >= _height_page_inzet && scrolled <= _height_page_achtergrond) {
				_active_page 	= 'inzet';
				document.title 	= "Inzet - Peterse Interim Finance";

			}
			if(scrolled >= _height_page_achtergrond && scrolled <= _height_page_vaardigheden) {
				_active_page 	= 'achtergrond';
				document.title 	= "Achtergrond - Peterse Interim Finance";
			}
			if(scrolled >= _height_page_vaardigheden && scrolled <= _height_page_contact) {
				_active_page 	= 'vaardigheden';
				document.title 	= "Vaardigheden - Peterse Interim Finance";
			}
			if(scrolled >= _height_page_contact) {
				_active_page 	= 'contact';
				document.title 	= "Contact - Peterse Interim Finance";
			}

			$('.js-button').removeClass('active');
			$('.js-button-' + _active_page).addClass('active');

		};
		
		
		/**
		Window: orientation
		**/
		this.windowOrientationChange = function() {
			
		};
		
}).apply(specific_interactions_window); 